<template>
  <v-layout row justify-center>
    <v-dialog v-model="accPlansDialogShow" persistent max-width="800px">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template>-->
      <template v-slot:activator="{ on }">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-btn
              :style="'right: 120px; top: 190px'"
              :class="['mt-5 mr-0', buttonState ? '' : 'red lighten-5']"
              v-on="on"
              absolute
              dark
              small
              fab
              top
              right
              color="primary"
              @click="openDocNameForm"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>Adicionar documento</span>
        </v-tooltip>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Cadastro de descrição de documentos</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="registerStandardAccPlansForm"
            v-model="validForm"
            lazy-validation
            class="mt-0 pt-0"
          >
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="formData.sub_type"
                    label="Descrição do documento"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>
                <!-- <v-flex xs6>
                  <v-text-field
                    :disabled="this.formData.id ? true : false"
                    v-model="formData.code"
                    label="Código do plano de conta"
                    :rules="$store.state.formRules.required"
                  />
                </v-flex>-->
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blueGrey darken-1" flat @click="closeAccPlanForm">Cancelar</v-btn>
          <v-btn color="primary" flat @click="doSave">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
const defaultAccPlansForm = {
  id: '',
  code: '',
  name: ''
}

export default {
  name: 'RegistrDocumentsName',

  props: {
    expenseGroupId: String,
    buttonState: Boolean,
    editData: Object,
    accPlansDialogShow: Boolean,
    closeAccPlanForm: Function,
    openDocNameForm: Function,
    reloadList: Function,
    condominiumsList: Array
  },

  data () {
    return {
      formData: { ...defaultAccPlansForm },
      validForm: true
    }
  },

  watch: {
    accPlansDialogShow (val) {
      this.formData = { ...defaultAccPlansForm }

      this.$refs.registerStandardAccPlansForm.resetValidation()

      if (val) {
        this.formData = { ...this.editData }
      }
    }
  },

  methods: {
    doSave () {
      if (!this.$refs.registerStandardAccPlansForm.validate()) {
        return
      }
      let query = { ...this.formData }
      query.type_id = this.expenseGroupId
      query.subtype = query.sub_type
      let obj = {
        url:
          '/api/subtypefile' + (this.formData.id ? `/${this.formData.id}` : ''),
        query: query,
        method: this.formData.id ? 'patch' : 'post'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        if (!response) {
          return
        }
        let obj = {
          message: 'Documento salvo com sucesso',
          title: 'Sucesso',
          callback: _ => {
            this.reloadList()
            this.closeAccPlanForm()
          },
          type: 'success',
          btConfirm: { name: 'Ok', show: true },
          btCancel: { name: 'Não', show: false }
        }
        this.$store.commit('confirmMessage/showConfirmMessage', obj)
      })
    },

    async getBuildings () {
      let obj = {
        url: '/api/financial/buildList/' + this.condominium_id,
        query: '',
        method: 'get'
      }
      await this.$store.dispatch('request/doRequest', obj).then(response => {
        this.buildingsList = response.data
        let allBuildings = {
          id: '0',
          name: 'Todas as áreas'
        }
        this.buildingsList.unshift(allBuildings)
      })
    }
  }
}
</script>
